/* eslint-disable react/display-name */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { TimesheetLabel } from 'modules/timesheet-labels/labelSchema';

import {
  SearchFacetType,
  SuggestionItemProp,
  DetailsControlProps
} from '../type';
import LabelFacetDetails from '../LabelFacetDetails';
import LabelOptionItem from '../OptionItem';
import { activityTag } from './tag';
import makeCriteriaProvider from './makeCriteriaProvider';
import { useActivityLabelFacetSearch } from './hooks/useActivityLabelFacetSearch';

const noActivityMessage = <FormattedMessage id="search.facets.noActivity" />;

export const getDetailsControl = (
  label: TimesheetLabel,
  onDropdownValueChange?: (mappedValue: any, label: any) => void,
  isDisable?: (label: any) => boolean,
  settingDopDownValue?: (label: any, setSelected: any) => void
): React.FC<DetailsControlProps> => ({
  selected,
  setSelected
}: DetailsControlProps) => {
  const {
    options,
    loading,
    searchHandler,
    hasMore
  } = useActivityLabelFacetSearch();
  return (
    <LabelFacetDetails
      selected={selected}
      setSelected={setSelected}
      options={options}
      loading={loading}
      searchHandler={searchHandler}
      label={label}
      noOptionsText={noActivityMessage}
      hasMore={hasMore}
      onDropdownValueChange={onDropdownValueChange}
      isDisable={isDisable}
      settingDopDownValue={settingDopDownValue}
    />
  );
};

const SuggestionItem: React.FC<SuggestionItemProp> = ({
  option
}: SuggestionItemProp) => (
  <LabelOptionItem testId={option.id} value={option.label} />
);

export const getActivityFacet = (
  label: TimesheetLabel,
  onDropdownValueChange?: (mappedValue: any, label: any) => void,
  isDisable?: (label: any) => boolean,
  settingDopDownValue?: (label: any, setSelected: any) => void
): SearchFacetType => {
  return {
    makeCriteriaProvider: makeCriteriaProvider(label),
    tag: activityTag,
    DetailsControl: getDetailsControl(
      label,
      onDropdownValueChange,
      isDisable,
      settingDopDownValue
    ),
    SuggestionItem: SuggestionItem
  };
};

export default getActivityFacet;
